import { useCallback } from "react";

import { fetchMe } from "../api/users";
import { setAssumptions, setLogin } from "../api/redux-toolkit/reducer/authSlice";
import { TOKEN_STORAGE_KEY } from "../config/auth-storage-keys";
import { authStorage } from "../config/session-storage";
import { useAuthDispatch, useAuthSelector } from "../stores/auth-hooks";

/** Reload GET /v1/users/me (user + effective assumptions). */
export function useRefreshProfile() {
  const dispatch = useAuthDispatch();
  const token = useAuthSelector((s) =>
    s.auth.isAuthenticated ? authStorage.getItem(TOKEN_STORAGE_KEY) : null,
  );

  return useCallback(async () => {
    if (!token) return null;
    const me = await fetchMe();
    dispatch(
      setLogin({
        accessToken: token,
        user: me.user,
        assumptions: me.assumptions,
      }),
    );
    dispatch(setAssumptions(me.assumptions));
    return me;
  }, [dispatch, token]);
}
